import React, { useState, useEffect } from 'react';
import Nodata from '../../ui/Nodata';
import SupportCard from './SupportCard';
import SupportForm from './SupportForm';
import axios from 'axios';
import Preloader from '../../Preloader/Preloader';

function Support({ moduleId }) {
  const server = process.env.REACT_APP_SUPPORT_SERVER_URL;
  const [supportData, setSupportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const getSupportData = async () => {
    await axios({
      method: 'get',
      url: `${server}/api/v1/support/tickets/`,
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
        ApiKey: `Token ${process.env.REACT_APP_SUPPORT_API_KEY}`,
      },
    })
      .then((res) => {
        setSupportData(res.data.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getSupportData();
  }, []);

  return (
    <>
      {!showForm && (
        <div className="d-flex justify-content-between align-items-center m-3">
          <span>Support Tickets</span>
          <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
            Create Ticket
          </button>
        </div>
      )}

      {showForm ? (
        <SupportForm
          handleSuccess={() => {
            setShowForm(false);
            getSupportData();
          }}
          handleCancel={() => setShowForm(false)}
        />
      ) : loading ? (
        <div className="d-flex flex-column" style={{ gap: '1rem' }}>
          {Array.from({ length: 3 }).map((_, index) => (
            <SkeletonLoader key={index} />
          ))}
        </div>
      ) : supportData && supportData.length !== 0 ? (
        <SupportCard moduleId={moduleId} support={supportData} />
      ) : (
        <Nodata title="You haven't asked for any support yet." src="/images/noComment.jpg" />
      )}
    </>
  );
}

function SkeletonLoader() {
  return (
    <div className="qa-card-skeleton w-100">
      <div className="header">
        <div className="user-info">
          <div className="skeleton name" />
          <div className="skeleton date" />
        </div>
        <div className="skeleton tag" />
        <div className="skeleton tag" />
      </div>
      <div className="skeleton message" />
      <div className="d-flex" style={{ gap: '1rem' }}>
        <div className="skeleton images w-50" />
        <div className="skeleton images w-50" />
      </div>
    </div>
  );
}

export default Support;
